// src/api/authService.js
import axios from "axios";

const API_URL = "https://d985-177-39-103-4.ngrok-free.app";

export const login = async (username, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, {
      username,
      password,
    });

    // Armazena diretamente os valores do response.data no localStorage
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("role", response.data.role);
    localStorage.setItem("nome", response.data.nome);

    return response.data; // Retorna os dados para uso, se necessário
  } catch (error) {
    throw new Error("Erro no login. Verifique suas credenciais.");
  }
};

export const cadastrarUsuario = async (usuario) => {
  try {
    const response = await axios.post(`${API_URL}/auth/register`, usuario);
    return response.data;
  } catch (error) {
    console.error("Erro ao cadastrar usuário:", error);
    throw error;
  }
};

export const loginWithGoogle = async (googleToken) => {
  const response = await axios.post(`${API_URL}/auth/google`, { googleToken });

  // Armazena diretamente os valores do response.data no localStorage
  localStorage.setItem("token", response.data.token);
  localStorage.setItem("role", response.data.role);
  localStorage.setItem("nome", response.data.nome);

  return response.data; // Retorna os dados para uso, se necessário
};

export const registerWithGoogle = async (googleToken) => {
  const response = await axios.post(`${API_URL}/auth/register/google`, {
    googleToken,
  });
  return response.data;
};

// Adiciona o método forgotPassword
export const forgotPassword = async (username) => {
  try {
    const response = await axios.post(`${API_URL}/auth/forgot-password`, {
      username,
    });

    return response.data;
  } catch (error) {
    throw new Error("Erro ao solicitar recuperação de senha. Tente novamente.");
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const response = await axios.post(
      `${API_URL}/auth/reset-password?token=${token}`,
      {
        newPassword,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error("Erro ao redefinir a senha.");
  }
};
